const styles = {
  container: {
    width: '100%'
  },
  leave: {
    padding: '0 10px'
  }
}

export default styles
